import { useTranslation } from 'react-i18next'
import { IconButton, Tooltip } from '@mui/material'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { useAppStore } from '@/store/appStore'

const CONTENT_ZOOM_MIN = 0.8
const CONTENT_ZOOM_MAX = 1.6
const CONTENT_ZOOM_STEP = 0.1

// Rounded so repeated 0.1 steps do not accumulate float error and miss the bounds.
const stepZoom = (zoom: number, delta: number) =>
  Math.min(CONTENT_ZOOM_MAX, Math.max(CONTENT_ZOOM_MIN, Math.round((zoom + delta) * 10) / 10))

export function ContentZoomControls() {
  const { t } = useTranslation()
  const zoom = useAppStore((s) => s.contentZoom)
  const setZoom = useAppStore((s) => s.setContentZoom)
  const percent = Math.round(zoom * 100)

  return (
    <div className="content-zoom-controls" role="group" aria-label={t('contentZoom.label', { percent })}>
      <Tooltip title={t('contentZoom.zoomOut')} placement="bottom">
        <span>
          <IconButton
            className="content-zoom-btn"
            size="medium"
            onClick={() => setZoom(stepZoom(zoom, -CONTENT_ZOOM_STEP))}
            disabled={zoom <= CONTENT_ZOOM_MIN}
            aria-label={t('contentZoom.zoomOut')}
          >
            <ZoomOutIcon fontSize="medium" />
          </IconButton>
        </span>
      </Tooltip>
      <span className="content-zoom-percent" aria-live="polite">{percent}%</span>
      <Tooltip title={t('contentZoom.zoomIn')} placement="bottom">
        <span>
          <IconButton
            className="content-zoom-btn"
            size="medium"
            onClick={() => setZoom(stepZoom(zoom, CONTENT_ZOOM_STEP))}
            disabled={zoom >= CONTENT_ZOOM_MAX}
            aria-label={t('contentZoom.zoomIn')}
          >
            <ZoomInIcon fontSize="medium" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={t('contentZoom.reset')} placement="bottom">
        <span>
          <IconButton
            className="content-zoom-btn"
            size="medium"
            onClick={() => setZoom(1)}
            disabled={zoom === 1}
            aria-label={t('contentZoom.reset')}
          >
            <RestartAltIcon fontSize="medium" />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  )
}
